import { makeStyles } from '@material-ui/core/styles';
import { condensedStyles } from 'core/components/theme/condensed-layout';

export const styles = (theme) => ({
  details: {
    marginTop: theme.spacing(4)
  },
  segmentForm: {
    padding: theme.spacing(6),
    paddingBottom: theme.spacing(2)
  },
  withFooter: {
    marginBottom: theme.spacing(32)
  },
  // Condensed: a second, smaller tab row under the customer workspace's tabs.
  tabs: condensedStyles(theme, {
    minHeight: 0,
    borderBottom: `1px solid ${theme.colorPalette.beige_60}`,
    '& [class*="MuiTabs-flexContainer"]': { justifyContent: 'flex-start' },
    '& [class*="MuiTabs-indicator"]': { height: 2 }
  }),
  tab: {
    fontSize: 12,
    textTransform: 'uppercase',
    fontWeight: 'bold',
    padding: 'unset',
    minWidth: 152,
    ...condensedStyles(theme, {
      fontSize: 13,
      fontWeight: 600,
      textTransform: 'none',
      minWidth: 0,
      minHeight: 36,
      '& [class*="MuiTab-wrapper"]': { padding: theme.spacing(0, 3) }
    })
  }
});

export default makeStyles(styles);
